import { Component, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { AuthService } from 'src/app/shared/services/auth.service';
import { DashboardService } from 'src/app/shared/services/dashboard.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  userId;
  user;
  userAssessments = [
    { name: 'Design & Manufacturing', link: "https://docs.google.com/forms/d/e/1FAIpQLSdVjIjUNtfXXL95gfNHygQch4i0onJx9ueK9MWdvPXXgiV-8w/viewform" },
    { name: 'Auto Electricals', link: "https://forms.gle/TmWv7uYHoxA9SxLn8" },
    { name: 'IOT', link: "https://forms.gle/ypQwSCw11UgR6PG98" },
    { name: 'Electric Car', link: "https://forms.gle/kXPaWLKQeRix9tx37" },
    { name: 'Solar & Charger', link: "https://forms.gle/nNidS4SiZp1qrrJY6" },
    { name: 'Welding', link: "https://forms.gle/XfGidDPyAFfzMV6D6" }
  ]; 

  constructor(
    public authService: AuthService,
    public dashboardService: DashboardService
  ) {
    this.userId = localStorage.getItem('useremail');
    console.log(this.userId)

    if(this.userId) this.dashboardService.getUser(this.userId).pipe(take(1))
    .subscribe(user => this.user = user)
   }

  ngOnInit(): void {
  }

}
